export default __webpack_public_path__ + "components/weather-icon/static/daylightshowers-cbb91dfd8770281f655dc649936d4f97.svg";